import { axios } from '@/lib/axios';

export const getUser = async (id: number) => {
    const { data } = await axios.get(`v1/admin/users/get-user?id=${id}`);
    return data;
};
